module.exports = __webpack_public_path__ + "static/media/logout.af358350.svg";